import { getIdTokenResult, User } from "firebase/auth";
import { doc, getDoc, setDoc, Timestamp } from "firebase/firestore";
import { firestore } from "../firebase";
import { mapDocToVCDBUser, VCDBUserCollection } from "../types/VCDBUser";

export const isAdmin = async (
  fireUser: User | null | undefined,
): Promise<boolean> => {
  if (!fireUser) {
    return false;
  }
  try {
    const idTokenResult = await getIdTokenResult(fireUser);
    return idTokenResult.claims.admin === true;
  } catch (error) {
    console.error("Error getting ID token result:", error);
    return false;
  }
};

export async function getOrCreateUser(user: User) {
  const userDoc = await getDoc(doc(firestore, VCDBUserCollection, user.uid));
  if (!userDoc.exists()) {
    await createUser(user);
  }
  return mapDocToVCDBUser(userDoc.id, userDoc.data());
}

export async function createUser(user: User) {
  const userDoc = doc(firestore, VCDBUserCollection, user.uid);
  await setDoc(userDoc, {
    id: user.uid,
    email: user.email,
    name: user.displayName,
    createdAt: Timestamp.now(),
  });
}

// Get user by UID
export async function getUserById(uid: string) {
  try {
    const userDoc = await getDoc(doc(firestore, VCDBUserCollection, uid));
    if (!userDoc.exists()) {
      throw new Error("User not found");
    }
    return mapDocToVCDBUser(userDoc.id, userDoc.data());
  } catch (error) {
    throw error;
  }
}
